/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Stage_InfraInputs */

const en_svc_stage_infra = /** @type {(inputs: Svc_Stage_InfraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-Throughput Infra`)
};

const ar_svc_stage_infra = /** @type {(inputs: Svc_Stage_InfraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنية تحتية عالية الإنتاجية`)
};

const bn_svc_stage_infra = /** @type {(inputs: Svc_Stage_InfraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হাই-থ্রুপুট ইনফ্রা`)
};

const de_svc_stage_infra = /** @type {(inputs: Svc_Stage_InfraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochdurchsatz-Infrastruktur`)
};

const es_svc_stage_infra = /** @type {(inputs: Svc_Stage_InfraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infraestructura de alto rendimiento`)
};

const fr_svc_stage_infra = /** @type {(inputs: Svc_Stage_InfraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infra à haut débit`)
};

const pt_svc_stage_infra = /** @type {(inputs: Svc_Stage_InfraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infraestrutura de alto rendimento`)
};

const zh_svc_stage_infra = /** @type {(inputs: Svc_Stage_InfraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高通量基础设施`)
};

const tr_svc_stage_infra = /** @type {(inputs: Svc_Stage_InfraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yüksek Verimli Altyapı`)
};

const ru_svc_stage_infra = /** @type {(inputs: Svc_Stage_InfraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инфраструктура с высокой пропускной способностью`)
};

const pl_svc_stage_infra = /** @type {(inputs: Svc_Stage_InfraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastruktura o dużej przepustowości`)
};

/**
* | output |
* | --- |
* | "High-Throughput Infra" |
*
* @param {Svc_Stage_InfraInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_stage_infra = /** @type {((inputs?: Svc_Stage_InfraInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Stage_InfraInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_stage_infra(inputs)
	if (locale === "bn") return bn_svc_stage_infra(inputs)
	if (locale === "de") return de_svc_stage_infra(inputs)
	if (locale === "es") return es_svc_stage_infra(inputs)
	if (locale === "fr") return fr_svc_stage_infra(inputs)
	if (locale === "pt") return pt_svc_stage_infra(inputs)
	if (locale === "zh") return zh_svc_stage_infra(inputs)
	if (locale === "tr") return tr_svc_stage_infra(inputs)
	if (locale === "ru") return ru_svc_stage_infra(inputs)
	if (locale === "pl") return pl_svc_stage_infra(inputs)
	return en_svc_stage_infra(inputs)
});